import React from 'react';
import { Link } from 'react-router-dom';
import resolveUrl, { isExternal } from '../utils/resolveUrl';

const SmartLink = ({ to, children }) => {
  const url = resolveUrl(to);
  if (isExternal(url)) {
    return <a href={url}>{children}</a>;
  }
  return <Link to={url}>{children}</Link>;
};

export default SmartLink;
